// const clubOneTinto = {
// 	slug: "clubOneTinto",
// 	title: "Tinto",
// 	tag: "1 botella al mes",
// 	price: 545,
// 	image: "https://cdn.shopify.com/s/files/1/0359/0874/7323/files/Clubde1.jpg?v=1716389386",
// 	text: "Comienza tu viaje en el mundo del vino con una botella de vino tinto cada mes."
// }

// const clubOneBlanco = {
// 	slug: "clubOneBlanco",
// 	title: "Blanco",
// 	tag: "1 botella al mes",
// 	price: 545,
// 	image: "https://cdn.shopify.com/s/files/1/0359/0874/7323/files/Clubde1-blanco.jpg?v=1716389386",
// 	text: "Comienza tu viaje en el mundo del vino con una botella de vino blanco cada mes."
// }

const clubBold = {
	id: 54727,
	price: 'price_1PLoGOIm2liO7pNXHApSmhra',
	slug: 'clubBold',
	title: 'Bold',
	tag: '2 tintos al mes',
	precio: 1195,
	image: 'https://cdn.shopify.com/s/files/1/0359/0874/7323/files/ClubTintos.jpg?v=1651279406',
	text: 'Para los audaces que quieren conocer a fondo el mundo de los tintos.'
}

const clubBright = {
	id: 54728,
	price: 'price_1PLoFBIm2liO7pNXVMaNxWh9',
	slug: 'clubBright',
	title: 'Bright',
	tag: '2 blancos al mes',
	precio: 1195,
	image: 'https://cdn.shopify.com/s/files/1/0359/0874/7323/files/ClubBright.jpg?v=1661290599',
	text: 'Para las mentes brillantes que aprecian y aman los vinos blancos.'
}

const clubExplorer = {
	id: 54729,
	price: 'price_1L8rOeIm2liO7pNXQYDQ0GdD',
	slug: 'clubExplorer',
	title: 'Explorer',
	tag: '1 blanco, 1 tinto al mes',
	precio: 995,
	image: 'https://cdn.shopify.com/s/files/1/0359/0874/7323/products/Club2.jpg?v=1651279740',
	text: 'Para los curiosos que quieren ir descubriendo.'
}

const clubFearless = {
	id: 54730,
	price: 'price_1L8rPOIm2liO7pNXIp5Kp9Z6',
	slug: 'clubFearless',
	title: 'Fearless',
	tag: '4 de todo al mes',
	precio: 1895,
	image: 'https://cdn.shopify.com/s/files/1/0359/0874/7323/products/Club4.jpg?v=1651279734',
	text: 'Para los intrépidos que quieren probar todo.'
}

const clubTest = {
	id: 1,
	price: 'price_1RJNIMIm2liO7pNXEcmROQ3h',
	slug: 'clubTest',
	title: 'Test',
	tag: 'Absolutamente nada',
	precio: 100,
	image: 'https://cdn.shopify.com/s/files/1/0359/0874/7323/products/Club4.jpg?v=1651279734',
	text: 'Para pruebas'
}

let clubs = {
	clubBold: clubBold,
	clubBright: clubBright,
	clubExplorer: clubExplorer,
	clubFearless: clubFearless,
	clubTest: clubTest
}

const estados = [
	'Aguascalientes',
	'Baja California',
	'Baja California Sur',
	'Campeche',
	'Chiapas',
	'Chihuahua',
	'Ciudad de México',
	'Coahuila',
	'Colima',
	'Durango',
	'Estado de México',
	'Guanajuato',
	'Guerrero',
	'Hidalgo',
	'Jalisco',
	'Michoacán',
	'Morelos',
	'Nayarit',
	'Nuevo León',
	'Oaxaca',
	'Puebla',
	'Querétaro',
	'Quintana Roo',
	'San Luis Potosí',
	'Sinaloa',
	'Sonora',
	'Tabasco',
	'Tamaulipas',
	'Tlaxcala',
	'Veracruz',
	'Yucatán',
	'Zacatecas'
]

export default {
	clubs,
	estados
}
